import { NgModule, Optional, SkipSelf } from '@angular/core';
import { FilesService } from '@core/services/files.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [FilesService],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
